if (!customElements.get('minico-explore-categories')) {
  class MinicoExploreCategories extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-explore-track]');
      this.progress = this.querySelector('[data-explore-progress]');
      this.prevButton = this.querySelector('[data-explore-prev]');
      this.nextButton = this.querySelector('[data-explore-next]');

      if (!this.track) return;

      this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
      window.addEventListener('resize', () => this.updateControls(), { passive: true });

      this.updateControls();
      this.setupScrollHint();
    }

    setupScrollHint() {
      const smallScreen = window.matchMedia('(max-width: 749px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!smallScreen.matches || reducedMotion.matches || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          this.playScrollHint();
        },
        { threshold: 0.4 }
      );

      observer.observe(this.track);
    }

    playScrollHint() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (maxScroll < 40 || this.track.scrollLeft > 4) return;

      this.track.classList.add('is-hinting');
      this.track.scrollTo({ left: 40, behavior: 'smooth' });

      setTimeout(() => {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(() => this.track.classList.remove('is-hinting'), 600);
      }, 600);
    }

    getActiveCards() {
      return Array.from(this.track.querySelectorAll('[data-explore-card]'));
    }

    scrollByCard(direction) {
      const cards = this.getActiveCards();
      if (!cards.length) return;

      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 16;
      this.track.scrollBy({
        left: direction * (cardWidth + gap),
        behavior: 'smooth',
      });
    }

    updateControls() {
      if (!this.track) return;

      const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      const ratio = maxScroll === 0 ? 0 : this.track.scrollLeft / maxScroll;

      if (this.progress) {
        // Unhide first: a hidden element measures 0 wide, which would zero the travel.
        this.progress.hidden = maxScroll < 4;

        const thumb = this.track.scrollWidth ? this.track.clientWidth / this.track.scrollWidth : 1;
        const travel = this.progress.clientWidth * (1 - thumb);

        this.progress.style.setProperty('--explore-thumb', String(Math.min(thumb, 1)));
        this.progress.style.setProperty('--explore-thumb-travel', `${travel}px`);
        this.progress.style.setProperty('--explore-progress', String(ratio));
      }

      const atStart = this.track.scrollLeft <= 4;
      const atEnd = this.track.scrollLeft >= maxScroll - 4;

      if (this.prevButton) this.prevButton.disabled = atStart || maxScroll < 4;
      if (this.nextButton) this.nextButton.disabled = atEnd || maxScroll < 4;
    }
  }

  customElements.define('minico-explore-categories', MinicoExploreCategories);
}
